/** @format */

import React from "react";
import StatItem from "./StatItem";

const StatsContainer = ({ totalCount, defaultCount, pendingCount }) => {
  const stats = [
    {
      title: "Total Applicants",
      count: totalCount,
      color: "#4C4DDC",
    },
    {
      title: "Default Applicants",
      count: defaultCount,
      color: "#DCDB4C",
    },
    {
      title: "Pending Applicants",
      count: pendingCount,
      color: "#4CDC93",
    },
  ];

  return (
    <div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-3">
        {stats.map((item, index) => (
          <StatItem key={index} {...item} />
        ))}
      </div>
    </div>
  );
};

export default StatsContainer;
